import { jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { css } from "styled-components";
import { useMainMenuContext } from "../hooks/index.js";
const Navbar = ({ children })=>{
    const { className, css: cssProp, style, 'data-testid': dataTestId, 'data-cy': dataCy, theme, position, isTransparent, isBlurred, activeSubMenu, currentBreakpointKey } = useMainMenuContext();
    const searchOverlayIsOpen = 'search' === activeSubMenu && ('md' === currentBreakpointKey || 'lg' === currentBreakpointKey);
    return /*#__PURE__*/ jsx("nav", {
        role: "navigation",
        "aria-label": "Men\xfa principal",
        className: clsx('main-menu w-full flex justify-center', theme.nav.textColorClassName, position, {
            [theme.nav.backgroundColorClassName]: !isTransparent || searchOverlayIsOpen,
            'top-0 left-0 right-0': 'sticky' === position || 'absolute' === position
        }, className),
        css: css`
        background-color: ${isBlurred && !searchOverlayIsOpen ? 'rgba(255, 255, 255, 0)' : ''};
        backdrop-filter: ${isBlurred && !searchOverlayIsOpen ? 'blur(20px)' : 'none'};
        transition: ${(props)=>props.theme.transition([
                'background-color',
                'color'
            ])};
        z-index: ${theme.nav.zIndex};
        height: ${theme.nav.height.xs}px;
        ${(props)=>props.theme.breakpoints.up('sm')} {
          height: ${theme.nav.height.sm}px;
        }
        ${(props)=>props.theme.breakpoints.up('md')} {
          height: ${theme.nav.height.md}px;
        }
        ${(props)=>props.theme.breakpoints.up('lg')} {
          height: ${theme.nav.height.lg}px;
        }
        ${cssProp}
      `,
        style: style,
        "data-testid": dataTestId,
        "data-cy": dataCy,
        children: children
    });
};
const ui_Navbar = Navbar;
export default ui_Navbar;
